import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import MarquSection from '../../components/MarquSection/MarquSection';
import Hero11 from '../../components/hero11/hero11';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import WorkSection from '../../components/WorkSection/WorkSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-5.png'

const AboutPage = () => {
    return (
        <Fragment>
            <div
                style={{
                    overflowX: "hidden",     // ✅ stop horizontal scroll
                    paddingTop: "90px",      // ✅ space below navbar
                }}
            >
                <Navbar
                    hclass={'wpo-site-header wpo-header-style'}
                    page={'about'}
                    Logo={Logo}
                    col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                    col2={'col-lg-5 col-md-6 col-6'}
                    col3={'col-lg-5 col-md-1 col-1'}
                    col4={'col-lg-2 col-md-2 col-2'}
                />

                <ScrollTextAnimation />

                <Hero11 />

                <MarquSection />

                <ProjectSection hclass={'wpo-project-section section-padding'} />

                <ServiceSection hclass={'wpo-service-section'} />

                <WorkSection hclass={'wpo-work-section section-padding'} />

                <Footer />

                <Scrollbar />
            </div>
        </Fragment>
    )
};

export default AboutPage;
